import { render, staticRenderFns } from "./c-decimal.vue?vue&type=template&id=74f65921&scoped=true"
import script from "./c-decimal.vue?vue&type=script&lang=js"
export * from "./c-decimal.vue?vue&type=script&lang=js"
import style0 from "./c-decimal.vue?vue&type=style&index=0&id=74f65921&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f65921",
  null
  
)

export default component.exports